// Display amounts in Chilean pesos. Keep calculation precision outside this helper.
const pesoFormatter = new Intl.NumberFormat('es-CL', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

// Returns the amount without a currency symbol; existing labels supply "$".
export const formatPesoAmount = (value) => {
  const amount = Number(value);
  return pesoFormatter.format(Math.abs(amount) < 0.5 ? 0 : amount);
};
